export default __webpack_public_path__ + "static/media/book-ride-img.f030efca.webp";